/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Update_AvailableInputs */

const en_us2_update_available = /** @type {(inputs: Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A new version is available`)
};

const pt_br2_update_available = /** @type {(inputs: Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nova versão disponível`)
};

const es_419_update_available = /** @type {(inputs: Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nueva versión disponible`)
};

const pt_pt2_update_available = /** @type {(inputs: Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nova versão disponível`)
};

const fr_fr2_update_available = /** @type {(inputs: Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelle version disponible`)
};

const de_de2_update_available = /** @type {(inputs: Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Version verfügbar`)
};

const it_it2_update_available = /** @type {(inputs: Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È disponibile una nuova versione`)
};

/**
* | output |
* | --- |
* | "A new version is available" |
*
* @param {Update_AvailableInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const update_available = /** @type {((inputs?: Update_AvailableInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Update_AvailableInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_update_available(inputs)
	if (locale === "es-419") return es_419_update_available(inputs)
	if (locale === "pt-PT") return pt_pt2_update_available(inputs)
	if (locale === "fr-FR") return fr_fr2_update_available(inputs)
	if (locale === "de-DE") return de_de2_update_available(inputs)
	if (locale === "it-IT") return it_it2_update_available(inputs)
	return en_us2_update_available(inputs)
});
export { update_available as "update.available" }